@for (service of services; track service) {
  <img src="assets/icons/services/service_{{ service.toLowerCase() }}.svg" alt="{{ service }}" />
}
